import { AudioOutlined } from '@ant-design/icons';

import { useCopilot } from '../../CopilotContext';

import styles from './ListeningIndicator.module.css';

export function ListeningIndicator() {
  const { isRecording, interimTranscript } = useCopilot();
  if (!isRecording) return null;
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <span className={styles.pulse} aria-hidden="true">
        <AudioOutlined />
      </span>
      <span className={styles.label}>{interimTranscript || 'Listening'}</span>
      <span className={styles.bars} aria-hidden="true">
        <span className={styles.bar} />
        <span className={styles.bar} />
        <span className={styles.bar} />
        <span className={styles.bar} />
      </span>
    </div>
  );
}
